var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("n-sms", {
        attrs: {
          visible: _vm.smsVisible,
          phone: _vm.orderDeliveryForm.phone,
          busType: 1
        },
        on: { submitClick: _vm.isLoanSubmit }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "确认收货",
            visible: _vm.deliveryDialogVisible,
            width: "700px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.deliveryDialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  attrs: { "label-position": "right", "label-width": "100px" }
                },
                [
                  _c("div", { staticClass: "mar10-b" }, [_vm._v("温馨提示：")]),
                  _c("div", { staticClass: "mar10-b" }, [
                    _vm._v(
                      "\n          点击“确认收货”,即视为您已经收到货品并已验收无误,并向平台发出向交易对方支付货款的指令,平台会即刻将您的交易货款支付至交易对方。\n        "
                    )
                  ]),
                  _c("div", { staticClass: "mar10-b" }, [
                    _vm._v("如有数量差额，平台将返还您差价。")
                  ]),
                  _c("div", { staticClass: "mar10-b" }, [
                    _vm._v(
                      "请您务必确保操作准确无误!否则,由此产生的财产损失,将由您自行承担。"
                    )
                  ]),
                  _c("div", { staticClass: "mar10-b" }, [
                    _vm._v(
                      "如果您使用融资款支付货款，若交易不真实而“确认收货”的，您可能构成诈骗并将承担由此产生的刑事、民事等法律责任。"
                    )
                  ]),
                  _vm.deliveryGoodsButton.isSellerVoucher == 1
                    ? _c(
                        "div",
                        { staticClass: "flex flex-column item mar20-b" },
                        [
                          _c("div", { staticClass: "flex mar15-b" }, [
                            _c("div", { staticClass: "f15 fb" }, [
                              _vm._v("买家上传凭证")
                            ])
                          ]),
                          _c("div", { staticClass: "flex flex-wrap upload" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex justify-center relative pointer box"
                              },
                              [
                                _c(
                                  "el-upload",
                                  {
                                    attrs: {
                                      limit: 30 - _vm.voucherPicNum,
                                      action:
                                        _vm.env.VUE_APP_fileserver +
                                        "persistentUpload",
                                      "file-list": _vm.voucherPicList,
                                      "list-type": "picture-card",
                                      "on-success": _vm.uploadVoucherSuccess,
                                      "before-upload": _vm.uploadBefore,
                                      "on-remove": _vm.uploadVoucherRemove,
                                      "on-exceed": _vm.uploadVoucherExceed
                                    }
                                  },
                                  [_c("i", { staticClass: "el-icon-plus" })]
                                )
                              ],
                              1
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "medium", type: "danger" },
                  on: {
                    click: function($event) {
                      return _vm.toDeliveryGoodsSubmit()
                    }
                  }
                },
                [_vm._v("确认收货")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "债务确认书",
            visible: _vm.refLoanDialogVisible,
            width: "400px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.refLoanDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "right", "label-width": "100px" } },
            [
              _c("div", { staticClass: "mar10-b" }, [_vm._v("温馨提示：")]),
              _c("div", { staticClass: "mar20-b" }, [
                _vm._v(
                  "您已成功使用“农信贷”支付本次订单，请在进行确认收货的同时一并签署《债务确认书》。"
                )
              ]),
              _c(
                "div",
                { staticClass: "flex-column item mar10-b" },
                [
                  _c("el-checkbox", {
                    model: {
                      value: _vm.orderDeliveryForm.loanCheck,
                      callback: function($$v) {
                        _vm.$set(_vm.orderDeliveryForm, "loanCheck", $$v)
                      },
                      expression: "orderDeliveryForm.loanCheck"
                    }
                  }),
                  _c("span", [
                    _vm._v(" 同意"),
                    _c(
                      "span",
                      {
                        staticClass: "mar5-l blue",
                        on: { click: _vm.readConfirmSee }
                      },
                      [_vm._v("《债务确认书》")]
                    )
                  ])
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.refLoanDialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.loanSubmit } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "二维码",
            visible: _vm.signatureDialogVisible,
            width: "260px"
          },
          on: {
            "update:visible": function($event) {
              _vm.signatureDialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "mar10-b mar10-l" }, [_vm._v("温馨提示：")]),
          _c("div", { staticClass: "mar20-b mar10-l" }, [
            _vm._v("该笔订单需要扫码签署电子签收单才可完成收货")
          ]),
          _c("el-row", { attrs: { type: "flex", justify: "center" } }, [
            _c("div", { staticClass: "qrCode-box" }, [
              _c("canvas", { ref: "qrCodeCanvas" })
            ])
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.signatureDialogVisible = false
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "确认收货",
            visible: _vm.editReceiveDialogVisible,
            width: "800px"
          },
          on: {
            "update:visible": function($event) {
              _vm.editReceiveDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-table",
            {
              staticClass: "mar20-b",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.orderDeliveryForm.receiveNumInfoList }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "goodsName", label: "商品名称", width: "180" }
              }),
              _c("el-table-column", {
                attrs: { label: "发货数量", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", { staticClass: "w110 mar5_r" }, [
                          _vm._v(" " + _vm._s(scope.row.deliveyNum) + " ")
                        ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "到货数量" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-input", {
                          staticStyle: { width: "100px" },
                          attrs: { placeholder: "到货数量", type: "text" },
                          on: {
                            input: function($event) {
                              scope.row.receivNum = _vm.formatNums(
                                scope.row.receivNum,
                                true
                              )
                            }
                          },
                          model: {
                            value: scope.row.receivNum,
                            callback: function($$v) {
                              _vm.$set(
                                scope.row,
                                "receivNum",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "scope.row.receivNum"
                          }
                        }),
                        _c("span", [
                          _vm._v(" " + _vm._s(scope.row.goodsUnit) + " ")
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-form",
            {
              staticClass: "mar20-b",
              attrs: {
                "label-suffix": "：",
                "label-position": "left",
                size: "medium"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "mar20-b",
                  attrs: { label: "原因", prop: "region" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择数量不符合原因",
                        clearable: ""
                      },
                      model: {
                        value: _vm.orderDeliveryForm.deliveryCause,
                        callback: function($$v) {
                          _vm.$set(_vm.orderDeliveryForm, "deliveryCause", $$v)
                        },
                        expression: "orderDeliveryForm.deliveryCause"
                      }
                    },
                    _vm._l(_vm.deliveryCauseTypeList, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.text, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "medium", type: "danger" },
                  on: {
                    click: function($event) {
                      return _vm.multipleReceiveGoods(-1)
                    }
                  }
                },
                [_vm._v("收货结清")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "确认收货",
            visible: _vm.editMultipleReceiveDialogVisible,
            width: "700px"
          },
          on: {
            "update:visible": function($event) {
              _vm.editMultipleReceiveDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-table",
            {
              staticClass: "mar20-b",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.orderDeliveryForm.receiveNumInfoList }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "goodsName", label: "商品名称", width: "180" }
              }),
              _c("el-table-column", {
                attrs: { label: "发货数量", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", { staticClass: "w110 mar5_r" }, [
                          _vm._v(" " + _vm._s(scope.row.deliveyNum) + " ")
                        ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "到货数量" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-input", {
                          staticStyle: { width: "100px" },
                          attrs: { placeholder: "到货数量", type: "text" },
                          on: {
                            input: function($event) {
                              scope.row.receivNum = _vm.formatNums(
                                scope.row.receivNum,
                                true
                              )
                            }
                          },
                          model: {
                            value: scope.row.receivNum,
                            callback: function($$v) {
                              _vm.$set(
                                scope.row,
                                "receivNum",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "scope.row.receivNum"
                          }
                        }),
                        _c("span", [
                          _vm._v(" " + _vm._s(scope.row.goodsUnit) + " ")
                        ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "原因" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "请选择数量不符合原因",
                              clearable: ""
                            },
                            model: {
                              value: scope.row.deliveryCause,
                              callback: function($$v) {
                                _vm.$set(scope.row, "deliveryCause", $$v)
                              },
                              expression: "scope.row.deliveryCause"
                            }
                          },
                          _vm._l(_vm.deliveryCauseTypeList, function(item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.text, value: item.value }
                            })
                          }),
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { fixed: "right", label: "操作", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function($event) {
                                return _vm.multipleReceiveGoods(scope.$index)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                scope.row.isFinallyReceive == 0
                                  ? "收货结清"
                                  : "确认收货"
                              )
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改收货地址",
            visible: _vm.eidtDeliveryDialogVisible,
            width: "700px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.eidtDeliveryDialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  attrs: { "label-position": "right", "label-width": "100px" }
                },
                [
                  _c("div", { staticClass: "mar10-b red" }, [
                    _vm._v("温馨提示：")
                  ]),
                  _c("div", { staticClass: "mar10-b red" }, [
                    _vm._v(
                      "修改后可能影响物流时效，建议提前和卖家确认完成后修改，地址仅可修改一次，请谨慎操作"
                    )
                  ]),
                  _c("div", { staticClass: "mar20-b" }, [
                    _c("div", { staticClass: "mar10-b fb" }, [
                      _vm._v("原地址：")
                    ]),
                    _c("div", { staticClass: "mar10-b" }, [
                      _vm._v(_vm._s(_vm.deliveryAddr))
                    ]),
                    _c("div", { staticClass: "mar10-b" }, [
                      _vm._v(
                        _vm._s(_vm.deliveryName) + " " + _vm._s(_vm.deliveryTel)
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "mar10-b flex fb" }, [
                    _c("div", { staticClass: "flex-auto" }, [
                      _vm._v("选择新的收货地址：")
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "red mar10-r cursor",
                        on: { click: _vm.addDelivery }
                      },
                      [_vm._v("新增地址")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "red cursor",
                        on: { click: _vm.refreshDelivery }
                      },
                      [_vm._v("刷新地址")]
                    )
                  ]),
                  _c("div", { staticClass: "mar20-b red" }, [
                    _vm._v("列表只展示运费不变且在商品配送范围内的收货地址")
                  ]),
                  _vm.memberDeliveryList.length > 0
                    ? _c(
                        "div",
                        { staticClass: "max_h" },
                        _vm._l(_vm.memberDeliveryList, function(item) {
                          return _c(
                            "el-radio",
                            {
                              key: item.deliveryId,
                              staticClass: "flex mar10-b items-center",
                              attrs: { label: item.deliveryId },
                              on: {
                                change: function($event) {
                                  return _vm.thisEditDeliveryCheck(item)
                                }
                              },
                              model: {
                                value: _vm.deliveryId,
                                callback: function($$v) {
                                  _vm.deliveryId = $$v
                                },
                                expression: "deliveryId"
                              }
                            },
                            [
                              _c("div", { staticClass: "mar10-b" }, [
                                _vm._v(_vm._s(item.allName))
                              ]),
                              _c("div", { staticClass: "mar10-b" }, [
                                _vm._v(
                                  _vm._s(item.name) + " " + _vm._s(item.tel)
                                )
                              ])
                            ]
                          )
                        }),
                        1
                      )
                    : _c("div", [
                        _c("div", { staticClass: "mar10-b red" }, [
                          _vm._v(
                            "暂无符合在配送范围内/运费不变要求的地址，请尝试添加新的收货地址"
                          )
                        ])
                      ])
                ]
              ),
              _vm.innerDelivery.orderInfo.contractId !== "0"
                ? _c(
                    "div",
                    { staticClass: "flex justify_center mar10-tb" },
                    [
                      _c("el-checkbox", {
                        model: {
                          value: _vm.innerDelivery.loanDeliveryCheck,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.innerDelivery,
                              "loanDeliveryCheck",
                              $$v
                            )
                          },
                          expression: "innerDelivery.loanDeliveryCheck"
                        }
                      }),
                      _c("span", { staticClass: "mar5-l" }, [
                        _vm._v("我已同意《"),
                        _c(
                          "span",
                          {
                            staticClass: "cursor",
                            on: {
                              click: function($event) {
                                return _vm.innerDeliveryCheck("1")
                              }
                            }
                          },
                          [_vm._v("订单地址修改协议")]
                        ),
                        _vm._v("》")
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "medium" },
                  on: {
                    click: function($event) {
                      ;(_vm.eidtDeliveryDialogVisible = false),
                        (_vm.innerDelivery.loanDeliveryCheck = false)
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "medium", type: "danger" },
                  on: {
                    click: function($event) {
                      return _vm.saveDelivery()
                    }
                  }
                },
                [_vm._v("确认")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改自提地址",
            visible: _vm.eidtSelfPickupDeliveryDialogVisible,
            width: "700px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.eidtSelfPickupDeliveryDialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  attrs: { "label-position": "right", "label-width": "100px" }
                },
                [
                  _c("div", { staticClass: "mar10-b red" }, [
                    _vm._v("温馨提示：")
                  ]),
                  _c("div", { staticClass: "mar10-b red" }, [
                    _vm._v(
                      "修改后可能影响提货时效，建议提前和卖家确认完成后修改，地址仅可修改一次，请谨慎操作"
                    )
                  ]),
                  _c("div", { staticClass: "mar20-b" }, [
                    _c("div", { staticClass: "mar10-b fb" }, [
                      _vm._v("原地址：")
                    ]),
                    _c("div", { staticClass: "mar10-b" }, [
                      _vm._v(_vm._s(_vm.deliveryAddr))
                    ]),
                    _c("div", { staticClass: "mar10-b" }, [
                      _vm._v(
                        _vm._s(_vm.deliveryName) + " " + _vm._s(_vm.deliveryTel)
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "mar10-b flex fb" }, [
                    _c("div", { staticClass: "flex-auto" }, [
                      _vm._v("选择新的自提地址：")
                    ])
                  ]),
                  _vm.shopDeliveryList.length > 0
                    ? _c(
                        "div",
                        { staticClass: "max_h" },
                        _vm._l(_vm.shopDeliveryList, function(item) {
                          return _c(
                            "el-radio",
                            {
                              key: item.deliveryId,
                              staticClass: "flex mar10-b items-center",
                              attrs: { label: item.deliveryId },
                              on: {
                                change: function($event) {
                                  return _vm.thisEditDeliveryCheck(item)
                                }
                              },
                              model: {
                                value: _vm.deliveryId,
                                callback: function($$v) {
                                  _vm.deliveryId = $$v
                                },
                                expression: "deliveryId"
                              }
                            },
                            [
                              _c("div", { staticClass: "mar10-b" }, [
                                _vm._v(_vm._s(item.allName))
                              ])
                            ]
                          )
                        }),
                        1
                      )
                    : _c("div", [
                        _c("div", { staticClass: "mar10-b red" }, [
                          _vm._v("暂无符合要求的自提地址")
                        ])
                      ])
                ]
              ),
              _vm.innerDelivery.orderInfo.contractId !== "0"
                ? _c(
                    "div",
                    { staticClass: "flex justify_center mar10-tb" },
                    [
                      _c("el-checkbox", {
                        model: {
                          value: _vm.innerDelivery.loanDeliveryCheck,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.innerDelivery,
                              "loanDeliveryCheck",
                              $$v
                            )
                          },
                          expression: "innerDelivery.loanDeliveryCheck"
                        }
                      }),
                      _c("span", { staticClass: "mar5-l" }, [
                        _vm._v("我已同意《"),
                        _c(
                          "span",
                          {
                            staticClass: "cursor",
                            on: {
                              click: function($event) {
                                return _vm.innerDeliveryCheck("2")
                              }
                            }
                          },
                          [_vm._v("订单地址修改协议")]
                        ),
                        _vm._v("》")
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "medium" },
                  on: {
                    click: function($event) {
                      ;(_vm.eidtSelfPickupDeliveryDialogVisible = false),
                        (_vm.innerDelivery.loanDeliveryCheck = false)
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "medium", type: "danger" },
                  on: {
                    click: function($event) {
                      return _vm.saveDelivery()
                    }
                  }
                },
                [_vm._v("确认")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "50%",
            title: "订单地址修改协议",
            visible: _vm.innerDeliveryVisible,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.innerDeliveryVisible = $event
            }
          }
        },
        [
          _c("div", [
            _c("div", { staticClass: "mar20-b" }, [
              _c("div", { staticClass: "mar10-b fb" }, [
                _vm._v(
                  "订单编号： " + _vm._s(_vm.innerDelivery.orderInfo.orderId)
                )
              ]),
              _c("div", { staticClass: "mar10-b fb" }, [
                _vm._v(
                  "对应合同及编号： " +
                    _vm._s(_vm.innerDelivery.orderInfo.contractId)
                )
              ]),
              _c("div", { staticClass: "mar10-b fb" }, [
                _vm._v(
                  "下单主体： " +
                    _vm._s(_vm.innerDelivery.orderInfo.orderSubject)
                )
              ]),
              _c("div", { staticClass: "mar10-b fb" }, [
                _vm._v(
                  "联系人： " + _vm._s(_vm.innerDelivery.orderInfo.boIdName)
                )
              ]),
              _c("div", { staticClass: "mar10-b fb" }, [
                _vm._v(
                  "联系电话： " + _vm._s(_vm.innerDelivery.orderInfo.boIdPhone)
                )
              ])
            ]),
            _c(
              "div",
              { staticClass: "mar10-b" },
              [
                _c("div", { staticClass: "mar10-b flex-auto fb" }, [
                  _vm._v("货品明细：")
                ]),
                _vm._l(_vm.innerDelivery.orderInfo.orderGoodsBoList, function(
                  item
                ) {
                  return [
                    _c("div", { key: item.goodsName, staticClass: "mar10-b" }, [
                      _vm._v(
                        _vm._s(item.goodsName) +
                          " " +
                          _vm._s("×" + item.goodsQuantity) +
                          " " +
                          _vm._s(item.goodsSpec)
                      )
                    ])
                  ]
                })
              ],
              2
            ),
            _c("div", { staticClass: "mar10-b flex" }, [
              _c("div", { staticClass: "flex-auto fb" }, [
                _vm._v(
                  _vm._s(
                    _vm.deliveryCheckType == "1"
                      ? "变更前订单收货地址"
                      : "变更前订单自提地址"
                  ) + "："
                )
              ]),
              _c("div", { staticClass: "mar10-b" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.innerDelivery.orderTransportDtl.linkman) +
                    " " +
                    _vm._s(_vm.innerDelivery.orderTransportDtl.tel) +
                    " " +
                    _vm._s(_vm.innerDelivery.orderTransportDtl.addr) +
                    "\n        "
                )
              ])
            ]),
            _c("div", { staticClass: "mar10-b flex" }, [
              _c("div", { staticClass: "flex-auto fb" }, [
                _vm._v(
                  _vm._s(
                    _vm.deliveryCheckType == "1"
                      ? "变更后订单收货地址"
                      : "变更后订单自提地址"
                  ) + "："
                )
              ]),
              _c("div", { staticClass: "mar10-b" }, [
                _vm._v(
                  _vm._s(_vm.innerDelivery.deliveryName) +
                    " " +
                    _vm._s(_vm.innerDelivery.deliveryTel) +
                    " " +
                    _vm._s(_vm.innerDelivery.deliveryAddr)
                )
              ])
            ]),
            _c("div", { staticClass: "mar20-b" }, [
              _c("div", { staticClass: "mar10-b fb" }, [
                _vm._v(
                  "操作人： " + _vm._s(_vm.innerDelivery.orderInfo.thisBoIdName)
                )
              ]),
              _c("div", { staticClass: "mar10-b fb" }, [
                _vm._v(
                  "操作人ID： " + _vm._s(_vm.innerDelivery.orderInfo.thisBoId)
                )
              ]),
              _c("div", { staticClass: "mar10-b fb" }, [
                _vm._v(
                  "联系电话： " +
                    _vm._s(_vm.innerDelivery.orderInfo.thisBoIdPhone)
                )
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }